import React from 'react';
import { Enterprise } from '../../../entity/entity.types';
import { EntityDefendedEnterprises } from '../../../entity/defended-enterprises/EntityDefendedEnterprises';
import { AllLawFirmEnterprisesModal } from '../../../modals/entity-lists/AllLawFirmEnterprisesModal';
import { fetchLawFirmEnterprises } from '../../lawFirm.api';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { EntityDecisionListModal } from '../../../modals/entity-lists/EntityDecisionListModal';
import { withModal, WithModalProps } from '../../../components/modal/withModal';

type Props = {
  lawOfficeIdGroup: string;
  name: string;
  displaySection: Function;
  decisionCount: number;
} & WithModalProps;

type State = {
  enterprises: Enterprise[];
  hasMore: boolean;
  pluralityState: number;
};

class RawEnterprisesRepresentedByLawFirm extends React.Component<Props, State> {
  state: State = {
    enterprises: [],
    hasMore: false,
    pluralityState: 0,
  };

  source = 'law_firm_enterprises';

  wording = `Représentée par ${this.props.name}`;

  async componentDidMount() {
    const { lawOfficeIdGroup, displaySection } = this.props;
    const {
      enterprises,
      hasMore,
      pluralityState,
    } = await fetchLawFirmEnterprises(lawOfficeIdGroup);
    this.setState({ enterprises, hasMore, pluralityState }, () => {
      if (pluralityState > 0) {
        displaySection();
      }
    });
  }

  handleSeeMoreEnterprisesClick = () => {
    const { openModal, name, lawOfficeIdGroup } = this.props;
    openModal((modalProps) => (
      <AllLawFirmEnterprisesModal
        name={name}
        lawOfficeIdGroup={lawOfficeIdGroup}
        source={this.source}
        wording={this.wording}
        {...modalProps}
      />
    ));
    doctrineAnalytics('LawFirm SeeMoreEnterprises', {
      law_office_id_group: this.props.lawOfficeIdGroup,
    });
  };

  handleClickDecision = (enterprise: Enterprise) => {
    const { openModal, lawOfficeIdGroup } = this.props;
    openModal((modalProps) => (
      <EntityDecisionListModal
        entityName={enterprise.name}
        wording={this.wording}
        params={{
          siren: enterprise.siren,
          lawOfficeId: lawOfficeIdGroup,
        }}
        source={this.source}
        {...modalProps}
      />
    ));
    doctrineAnalytics('Entity SeeEntityDecisions', {
      source: this.source,
    });
  };

  render() {
    const { lawOfficeIdGroup, name, decisionCount } = this.props;
    const { pluralityState, enterprises, hasMore } = this.state;

    if (pluralityState === 0) {
      return null;
    }

    return (
      <EntityDefendedEnterprises
        enterprises={enterprises}
        pluralityState={pluralityState}
        entityName={name}
        entityType="lawFirm"
        entityId={lawOfficeIdGroup}
        source={this.source}
        decisionCount={decisionCount}
        handleSeeMoreEnterprisesClick={
          hasMore ? this.handleSeeMoreEnterprisesClick : () => {}
        }
        handleClickDecision={this.handleClickDecision}
        wording={this.wording}
      />
    );
  }
}

export const EnterprisesRepresentedByLawFirm = withModal(
  RawEnterprisesRepresentedByLawFirm,
);
